import { createSlice } from "@reduxjs/toolkit";
import { getUserProfile } from "@/state/profileSlice";
import { defaultTrailerType } from "@/utils/constants";
import { protectedPaths } from "@/routing/paths";
import { today, tomorrow } from "@/utils/date";

const initialSearchType =
  window.location.pathname === protectedPaths[1]
    ? "load_rates"
    : window.location.pathname === protectedPaths[2] || window.location.pathname === protectedPaths[0]
      ? "market_potential"
      : window.location.pathname === protectedPaths[4]
        ? "company_analytics"
        : null;

const initialState = {
  buttonFocus: false,
  pickup: null,
  delivery: null,
  pickupQuery: "",
  deliveryQuery: "",
  pickupRadius: null,
  deliveryRadius: null,
  trailerType: defaultTrailerType,
  outboundSearch: false,
  pickupDate: today,
  pickupDateEnd: null,
  deliveryDate: tomorrow,
  deliveryDateEnd: null,
  searchType: initialSearchType,
};

const searchInputSlice = createSlice({
  name: "searchInput",
  initialState,
  reducers: {
    toggleFocusOnButton: (state) => {
      state.buttonFocus = !state.buttonFocus;
    },
    setPickup: (state, action) => {
      state.pickup = action.payload;
    },
    setDelivery: (state, action) => {
      state.delivery = action.payload;
    },
    setPickupQuery: (state, action) => {
      state.pickupQuery = action.payload;
    },
    setDeliveryQuery: (state, action) => {
      state.deliveryQuery = action.payload;
    },
    setPickupDate: (state, action) => {
      state.pickupDate = action.payload;
    },
    setPickupDateEnd: (state, action) => {
      state.pickupDateEnd = action.payload;
    },
    setDeliveryDate: (state, action) => {
      state.deliveryDate = action.payload;
    },
    setDeliveryDateEnd: (state, action) => {
      state.deliveryDateEnd = action.payload;
    },
    setTrailerType: (state, action) => {
      state.trailerType = action.payload;
    },
    setPickupRadius: (state, action) => {
      state.pickupRadius = action.payload;
    },
    setDeliveryRadius: (state, action) => {
      state.deliveryRadius = action.payload;
    },
    setSearchType: (state, action) => {
      state.searchType = action.payload;
    },
    clearInputs: () => {
      return initialState;
    },
    clearInputsExceptFixedDropdowns: (state) => {
      const { trailerType: _t, pickupRadius: _p, deliveryRadius: _d, ...rest } = initialState;
      return {
        ...state,
        ...rest,
      };
    },
    setInputSearch: (state, action) => {
      return {
        ...state,
        ...action.payload,
      };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getUserProfile.fulfilled, (state, action) => {
      state.trailerType = action.payload.trailerType;
    });
  },
});

export const {
  toggleFocusOnButton,
  setPickup,
  setDelivery,
  setPickupQuery,
  setDeliveryQuery,
  setPickupRadius,
  setDeliveryRadius,
  setPickupDate,
  setPickupDateEnd,
  setDeliveryDate,
  setDeliveryDateEnd,
  setTrailerType,
  setSearchType,
  clearInputs,
  clearInputsExceptFixedDropdowns,
  setInputSearch,
} = searchInputSlice.actions;
export default searchInputSlice.reducer;
